export default __webpack_public_path__ + "static/flowerReview-a5a52ad4a59185218e138b4e07ce08bd.png";